import { Country } from '@skin-seoul/service';

export interface Threshold {
  freeShipping: number;
  tenPercentOff: number;
  fifteenPercentOff?: number;
}

export enum MilestoneKey {
  FreeShipping = 'freeShipping',
  TenPercentOff = 'tenPercentOff',
  FifteenPercentOff = 'fifteenPercentOff',
}

export interface MilestoneMeta {
  key: MilestoneKey;
  title: string;
  anchorPercent: number;
}

export interface CampaignMilestone {
  key: MilestoneKey;
  title: string;
  threshold: number;
  achieved: boolean;
  statusText: string;
  anchorPercent: number;
}

// ===== Data =====
export const thresholdsPerCountry: Record<Country, Threshold> = {
  [Country.UnitedStates]: { freeShipping: 49, tenPercentOff: 60, fifteenPercentOff: 90 },
  [Country.Australia]: { freeShipping: 55, tenPercentOff: 80, fifteenPercentOff: 110 },
  [Country.NewZealand]: { freeShipping: 60, tenPercentOff: 80, fifteenPercentOff: 120 },
  [Country.Canada]: { freeShipping: 69, tenPercentOff: 90, fifteenPercentOff: 120 },
  [Country.UnitedKingdom]: { freeShipping: 45, tenPercentOff: 60, fifteenPercentOff: 70 },
  [Country.Singapore]: { freeShipping: 49, tenPercentOff: 70, fifteenPercentOff: 100 },
  [Country.Malaysia]: { freeShipping: 170, tenPercentOff: 240, fifteenPercentOff: 340 },
  [Country.UnitedArabEmirates]: { freeShipping: 180, tenPercentOff: 230, fifteenPercentOff: 320 },
  [Country.SaudiArabia]: { freeShipping: 220, tenPercentOff: 280, fifteenPercentOff: 360 },
  [Country.Qatar]: { freeShipping: 215, tenPercentOff: 270, fifteenPercentOff: 350 },
  [Country.Netherlands]: { freeShipping: 48, tenPercentOff: 60, fifteenPercentOff: 80 },
  [Country.Belgium]: { freeShipping: 48, tenPercentOff: 60, fifteenPercentOff: 80 },
  [Country.Germany]: { freeShipping: 48, tenPercentOff: 60, fifteenPercentOff: 80 },
  [Country.France]: { freeShipping: 48, tenPercentOff: 60, fifteenPercentOff: 80 },
  [Country.Poland]: { freeShipping: 230, tenPercentOff: 290, fifteenPercentOff: 370 },
  [Country.Spain]: { freeShipping: 48, tenPercentOff: 60, fifteenPercentOff: 80 },
};

export const BMSM_BASE_MILESTONES_META: readonly MilestoneMeta[] = [
  { key: MilestoneKey.FreeShipping, title: 'Free Shipping', anchorPercent: 0.2 },
  { key: MilestoneKey.TenPercentOff, title: '10% OFF', anchorPercent: 0.8 },
] as const;

export const BMSM_WITH_FIFTEEN_MILESTONES_META: readonly MilestoneMeta[] = [
  { key: MilestoneKey.FreeShipping, title: 'Free Shipping', anchorPercent: 0.2 },
  { key: MilestoneKey.TenPercentOff, title: '10% OFF', anchorPercent: 0.5 },
  { key: MilestoneKey.FifteenPercentOff, title: '15% OFF', anchorPercent: 0.8 },
] as const;

export const BMSM_PROGRESS_SEGMENTS = {
  withoutFifteen: { firstEndPercent: 20, secondEndPercent: 80, endPercent: 100 },
  withFifteen: { firstEndPercent: 20, secondEndPercent: 60, endPercent: 100 },
} as const;
